import Header from "./Components/About/Header"
import Intro from "./Components/About/Intro"
import Map from "./Components/About/Map"
import NewYork from "./Components/About/NewYork"
import Values from "./Components/About/Values"
import CTA from './Components/CTA'

const About = () => {
    return (
        <div className="select-none">
            <Header></Header>
            <Intro></Intro>
            <NewYork></NewYork>
            <Values></Values>
            <Map></Map>
            <CTA></CTA>
        </div>
    )
}

export default About